module.exports = require('./support.min.js')
